'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentBoletoAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "white",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M17.7156 46.9024H20.2883V11H17.7156V46.9024Z", fill: "#1A1918" }),
      /* @__PURE__ */ jsx("path", { d: "M21.0999 46.9024H21.8976V11H21.0999V46.9024Z", fill: "#1A1918" }),
      /* @__PURE__ */ jsx("path", { d: "M22.5919 46.9024H24.0191V11H22.5919V46.9024Z", fill: "#1A1918" }),
      /* @__PURE__ */ jsx("path", { d: "M25.3965 46.9024H26.1929V11H25.3965V46.9024Z", fill: "#1A1918" }),
      /* @__PURE__ */ jsx("path", { d: "M26.5407 46.9024H27.1549V11H26.5407V46.9024Z", fill: "#1A1918" }),
      /* @__PURE__ */ jsx("path", { d: "M15.7584 46.9024H16.5561V11H15.7584V46.9024Z", fill: "#1A1918" }),
      /* @__PURE__ */ jsx("path", { d: "M14 46.9024H15.4272V11H14V46.9024Z", fill: "#1A1918" }),
      /* @__PURE__ */ jsx("path", { d: "M31.4171 46.9024H33.9898V11H31.4171V46.9024Z", fill: "#1A1918" }),
      /* @__PURE__ */ jsx("path", { d: "M34.8014 46.9024H35.5978V11H34.8014V46.9024Z", fill: "#1A1918" }),
      /* @__PURE__ */ jsx("path", { d: "M36.2934 46.9024H37.7205V11H36.2934V46.9024Z", fill: "#1A1918" }),
      /* @__PURE__ */ jsx("path", { d: "M39.0966 46.9024H39.8944V11H39.0966V46.9024Z", fill: "#1A1918" }),
      /* @__PURE__ */ jsx("path", { d: "M40.2408 46.9024H40.8564V11H40.2408V46.9024Z", fill: "#1A1918" }),
      /* @__PURE__ */ jsx("path", { d: "M29.4599 46.9024H30.2577V11H29.4599V46.9024Z", fill: "#1A1918" }),
      /* @__PURE__ */ jsx("path", { d: "M27.7015 46.9024H29.1287V11H27.7015V46.9024Z", fill: "#1A1918" }),
      /* @__PURE__ */ jsx("path", { d: "M41.8668 46.9024H43.2939V11H41.8668V46.9024Z", fill: "#1A1918" }),
      /* @__PURE__ */ jsx("path", { d: "M44.67 46.9024H45.4678V11H44.67V46.9024Z", fill: "#1A1918" }),
      /* @__PURE__ */ jsx("path", { d: "M45.8156 46.9024H46.4298V11H45.8156V46.9024Z", fill: "#1A1918" }),
      /* @__PURE__ */ jsx("path", { d: "M48.7348 46.9024H49.5326V11H48.7348V46.9024Z", fill: "#1A1918" }),
      /* @__PURE__ */ jsx("path", { d: "M46.9764 46.9024H48.4035V11H46.9764V46.9024Z", fill: "#1A1918" }),
      /* @__PURE__ */ jsx("path", { d: "M50.5925 46.9024H51.3903V11H50.5925V46.9024Z", fill: "#1A1918" }),
      /* @__PURE__ */ jsx("path", { d: "M51.7368 46.9024H52.351V11H51.7368V46.9024Z", fill: "#1A1918" }),
      /* @__PURE__ */ jsx("path", { d: "M54.6559 46.9024H55.4537V11H54.6559V46.9024Z", fill: "#1A1918" }),
      /* @__PURE__ */ jsx("path", { d: "M52.8975 46.9024H54.3247V11H52.8975V46.9024Z", fill: "#1A1918" }),
      /* @__PURE__ */ jsx("path", { d: "M56.1494 46.9024H58.7221V11H56.1494V46.9024Z", fill: "#1A1918" }),
      /* @__PURE__ */ jsx("path", { d: "M59.5337 46.9024H60.3315V11H59.5337V46.9024Z", fill: "#1A1918" }),
      /* @__PURE__ */ jsx("path", { d: "M61.0257 46.9024H62.4528V11H61.0257V46.9024Z", fill: "#1A1918" }),
      /* @__PURE__ */ jsx("path", { d: "M63.8289 46.9024H64.6267V11H63.8289V46.9024Z", fill: "#1A1918" }),
      /* @__PURE__ */ jsx("path", { d: "M64.9731 46.9024H65.5887V11H64.9731V46.9024Z", fill: "#1A1918" }),
      /* @__PURE__ */ jsx("path", { d: "M66.5991 46.9024H69.1718V11H66.5991V46.9024Z", fill: "#1A1918" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M16.9109 46.9604H66.2347V32.5398H16.9109V46.9604Z",
          fill: "#F3F6F9"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M17.8408 46.4071V33.3597H22.4255C23.194 33.3287 23.9601 33.4634 24.672 33.7546C25.2295 34.0133 25.692 34.4403 25.9945 34.9755C26.308 35.4951 26.4743 36.0903 26.4754 36.6973C26.4817 37.869 25.8208 38.9423 24.7717 39.4643C25.4566 39.6564 26.0568 40.0737 26.4754 40.6489C26.8802 41.2263 27.0894 41.9182 27.0726 42.6231C27.0772 43.2118 26.9529 43.7943 26.7085 44.3298C26.5083 44.7989 26.2015 45.2149 25.8124 45.5447C25.4151 45.8476 24.9603 46.0667 24.4757 46.1884C23.8302 46.3469 23.1667 46.4204 22.5021 46.4071L17.8408 46.4071ZM19.4617 38.8447H22.104C22.6224 38.8665 23.1413 38.8154 23.6454 38.6927C24.021 38.5879 24.3492 38.3575 24.5755 38.0399C24.7942 37.7001 24.9034 37.3015 24.8886 36.8978C24.8977 36.4965 24.7963 36.1005 24.5954 35.7531C24.4123 35.4302 24.1152 35.1874 23.7623 35.0724C23.155 34.9234 22.5296 34.862 21.9049 34.8902H19.4617V38.8447ZM19.4617 44.8761H22.5049C22.8739 44.8863 23.2431 44.8651 23.6085 44.8125C23.9402 44.7579 24.2575 44.637 24.5414 44.457C24.807 44.2719 25.0197 44.0208 25.1585 43.7284C25.3255 43.3854 25.4084 43.0075 25.4001 42.6261C25.4115 42.1762 25.2887 41.7331 25.0474 41.3532C24.8195 40.9964 24.4762 40.7284 24.0748 40.5938C23.495 40.4259 22.892 40.352 22.2888 40.3752H19.4617V44.8761V44.8761Z",
          fill: "#1A1918"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M28.5403 41.6784C28.4221 40.2487 28.9198 38.8366 29.9082 37.797C30.6652 37.0995 31.6638 36.7237 32.6928 36.7493C33.8265 36.7145 34.9179 37.1811 35.676 38.0247C36.4945 39.0086 36.9083 40.2669 36.8335 41.5446C36.8781 42.5254 36.7033 43.5038 36.3219 44.4085C35.9971 45.086 35.477 45.6508 34.8286 46.0303C34.1826 46.4139 33.4441 46.6134 32.6928 46.6075C31.5522 46.6501 30.4513 46.1853 29.6865 45.3381C28.8595 44.3048 28.4505 42.9987 28.5403 41.6783V41.6784ZM30.0761 41.6814C30.0036 42.6439 30.2659 43.602 30.8185 44.3934C31.2709 44.9639 31.9594 45.2963 32.6876 45.2957C33.4158 45.2951 34.1038 44.9616 34.5553 44.3904C35.1105 43.5818 35.3724 42.6078 35.2977 41.6299C35.3646 40.6869 35.1 39.7502 34.5496 38.9815C34.0981 38.4126 33.4119 38.0805 32.6856 38.0792C31.9593 38.0779 31.2719 38.4077 30.8184 38.975C30.2662 39.7645 30.0039 40.7206 30.0761 41.6814H30.0761Z",
          fill: "#1A1918"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M38.5598 46.4069H40.0614V33.3596H38.5598V46.4069Z",
          fill: "#1A1918"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M48.4261 43.3457L49.9789 43.5643C49.7894 44.442 49.3131 45.2317 48.6251 45.8087C47.9015 46.3621 47.007 46.6447 46.0968 46.6075C44.934 46.6616 43.8077 46.1939 43.0253 45.3321C42.2144 44.3236 41.8097 43.0486 41.8904 41.7572C41.8067 40.4273 42.2146 39.113 43.0366 38.0641C43.7785 37.1972 44.8736 36.7136 46.0141 36.7493C47.1238 36.7172 48.188 37.1909 48.9069 38.0369C49.7118 39.0678 50.1113 40.3578 50.0299 41.6633C50.0299 41.7571 50.0271 41.9001 50.0214 42.0884H43.4263C43.4201 42.9532 43.7112 43.7938 44.2509 44.4696C44.7128 45.0057 45.3894 45.3084 46.0969 45.2957C46.6051 45.3095 47.1021 45.1449 47.5017 44.8306C47.9463 44.4349 48.2673 43.9193 48.4261 43.3456V43.3457ZM43.5114 40.7761H48.4431C48.4293 40.1381 48.2329 39.5174 47.8771 38.9876C47.4479 38.3938 46.7552 38.0477 46.0227 38.0611C45.3655 38.0481 44.7341 38.3168 44.2878 38.7993C43.8002 39.3437 43.5246 40.0454 43.5114 40.7761Z",
          fill: "#1A1918"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M55.1353 44.9767L55.34 46.392C54.9699 46.4805 54.5913 46.5284 54.2108 46.5349C53.7718 46.5595 53.3343 46.4638 52.9455 46.2582C52.6618 46.0914 52.4402 45.8366 52.3143 45.5326C52.1554 44.9141 52.094 44.2745 52.1322 43.6371V38.1889H51.0229V36.9498H52.1322V34.611L53.6335 33.6486V36.9498H55.1352V38.1889H53.6335V43.7285C53.615 44.0254 53.6419 44.3233 53.7134 44.6121C53.7635 44.7408 53.8531 44.8504 53.9692 44.9252C54.1259 45.0104 54.3032 45.0503 54.4813 45.0403C54.7005 45.0353 54.9191 45.014 55.1352 44.9767",
          fill: "#1A1918"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M56.054 41.6784C55.936 40.2488 56.4337 38.8367 57.4219 37.797C58.1789 37.0995 59.1775 36.7237 60.2065 36.7493C61.3403 36.7145 62.4318 37.1811 63.1901 38.0247C64.0087 39.0086 64.4225 40.2669 64.3476 41.5446C64.3923 42.5254 64.2174 43.5039 63.8356 44.4085C63.5109 45.0861 62.9909 45.651 62.3423 46.0303C61.6964 46.4139 60.9578 46.6135 60.2065 46.6075C59.0659 46.65 57.9651 46.1852 57.2002 45.3381C56.3732 44.3048 55.9642 42.9987 56.054 41.6783L56.054 41.6784ZM57.5898 41.6814C57.5175 42.6439 57.7798 43.6019 58.3321 44.3934C58.7847 44.9639 59.4733 45.2963 60.2015 45.2957C60.9298 45.2951 61.6178 44.9616 62.0695 44.3904C62.6244 43.5817 62.8863 42.6078 62.8118 41.6299C62.8785 40.6869 62.6139 39.7503 62.0638 38.9815C61.6121 38.4126 60.9259 38.0805 60.1995 38.0792C59.4731 38.0779 58.7857 38.4077 58.3321 38.975C57.7801 39.7646 57.5178 40.7207 57.5897 41.6814H57.5898Z",
          fill: "#1A1918"
        }
      )
    ]
  }
);
const VpPaymentBoletoAsset = forwardRef(PaymentBoletoAsset);

export { VpPaymentBoletoAsset as default };
